import { Message } from './message'
import { Injectable } from '@angular/core'

@Injectable()
export class MessageSerializer {
  fromJson(json: any): Message {
    const message = json

    return message
  }

  toJson(message: Message): any {
    return {
      ...message
    }
  }
}
